import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromScheduledApplications from './scheduled-applications.reducer';
import { ScheduledApplicationsState } from './scheduled-applications.state';

export const selectScheduledApplicationsState =
  createFeatureSelector<ScheduledApplicationsState>('scheduledApplications');

export const selectAllScheduledApplications = createSelector(
  selectScheduledApplicationsState,
  fromScheduledApplications.selectAllScheduledApplications
);

export const selectScheduledApplicationsWithConvertedLocalTime = createSelector(
  selectAllScheduledApplications,
  (applications) =>
    applications.map((application) => ({
      ...application,
      applyFrom: application.applyFrom,
    }))
);
